import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { usePeopleAndTeamsQuery } from '../../../common/clients/people-and-teams-supplier';
import { messages } from './messages';
import { useDefaultSuppliers } from '../../result-supplier';
import { MAX_ITEMS_PER_SECTION, getSections } from './sections';
import { TownsquareScope } from './types';
import getAtlasViewAllRedirectUrl, { createProfileLink, createTeamProfileLink } from './url-generators';
export var TOWNSQUARE_PRODUCT_ID = 'townsquare';
var sectionSortOrder = [TownsquareScope.TownsquareProject, TownsquareScope.TownsquareGoal, TownsquareScope.People, TownsquareScope.Teams, TownsquareScope.TownsquareTag, TownsquareScope.TownsquareHelpLink, TownsquareScope.TownsquareLearning];

/**
 * Sorting sections to match the order defined in the array {sectionSortOrder}
 * While this should not happen, if the section is not part of the array, it is considered to be at the end.
 */
var sortSections = function sortSections(sectionA, sectionB) {
  var indexA = sectionSortOrder.indexOf(sectionA.id);
  var indexB = sectionSortOrder.indexOf(sectionB.id);
  if (indexA === -1) {
    return 1;
  }
  if (indexB === -1) {
    return -1;
  }
  return indexA - indexB;
};
export var useTownsquareSuppliers = function useTownsquareSuppliers(_ref) {
  var userTeamConfig = _ref.userTeamConfig,
    preQueryItemSupplier = _ref.preQueryItemSupplier,
    postQueryItemSupplier = _ref.postQueryItemSupplier,
    workspaces = _ref.workspaces,
    organizationId = _ref.organizationId,
    isGlobalExperienceWorkspace = _ref.isGlobalExperienceWorkspace;
  var intl = useIntl();
  var orgId = organizationId !== null && organizationId !== void 0 ? organizationId : userTeamConfig === null || userTeamConfig === void 0 ? void 0 : userTeamConfig.context.organizationId;
  var itemSuppliers = useDefaultSuppliers(TOWNSQUARE_PRODUCT_ID, getSections(intl, workspaces, isGlobalExperienceWorkspace, orgId), {
    preQueryItemSupplier: preQueryItemSupplier,
    postQueryItemSupplier: postQueryItemSupplier
  });

  // If we are in a global experience workspace, we need to set the product key to 'people'
  if (userTeamConfig) {
    userTeamConfig.context.productKey = isGlobalExperienceWorkspace ? 'people' : userTeamConfig === null || userTeamConfig === void 0 ? void 0 : userTeamConfig.context.productKey;
  }
  var peopleAndTeamSupplier = usePeopleAndTeamsQuery({
    people: {
      id: TownsquareScope.People,
      title: intl.formatMessage(messages.townsquare_people_heading),
      viewAllLinkGenerator: function viewAllLinkGenerator(query) {
        return getAtlasViewAllRedirectUrl('people', query, workspaces, isGlobalExperienceWorkspace, orgId);
      },
      viewAllLinkRenderer: function viewAllLinkRenderer() {
        return /*#__PURE__*/React.createElement(FormattedMessage, messages.townsquare_people_view_all);
      }
    },
    teams: {
      id: TownsquareScope.Teams,
      title: intl.formatMessage(messages.townsquare_teams_heading),
      viewAllLinkGenerator: function viewAllLinkGenerator(query) {
        return getAtlasViewAllRedirectUrl('teams', query, workspaces, isGlobalExperienceWorkspace, orgId);
      },
      viewAllLinkRenderer: function viewAllLinkRenderer() {
        return /*#__PURE__*/React.createElement(FormattedMessage, messages.townsquare_teams_view_all);
      }
    }
  }, MAX_ITEMS_PER_SECTION);
  var preQueryItemSupplierWithPeopleAndTeams = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
      var _people$sections;
      var existingSections, people, unsortedSections;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return itemSuppliers.preQueryItemSupplier(args);
          case 2:
            existingSections = _context.sent;
            if (!userTeamConfig) {
              _context.next = 9;
              break;
            }
            _context.next = 6;
            return peopleAndTeamSupplier('', _objectSpread({
              resolveUserUrl: function resolveUserUrl(userId) {
                return createProfileLink(userId, isGlobalExperienceWorkspace, orgId);
              },
              resolveTeamUrl: function resolveTeamUrl(teamId) {
                return createTeamProfileLink(teamId, isGlobalExperienceWorkspace, orgId);
              }
            }, userTeamConfig));
          case 6:
            _context.t0 = _context.sent;
            _context.next = 10;
            break;
          case 9:
            _context.t0 = null;
          case 10:
            people = _context.t0;
            unsortedSections = [].concat(_toConsumableArray(existingSections.sections), _toConsumableArray((_people$sections = people === null || people === void 0 ? void 0 : people.sections) !== null && _people$sections !== void 0 ? _people$sections : []));
            return _context.abrupt("return", {
              size: unsortedSections.length,
              sections: unsortedSections.sort(sortSections)
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function preQueryItemSupplierWithPeopleAndTeams(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var postQueryItemSupplierWithPeopleAndTeams = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
      var _people$sections2;
      var existingSections, filters, selectedWorkspace, people, unsortedSections;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return itemSuppliers.postQueryItemSupplier(args);
          case 2:
            existingSections = _context2.sent;
            filters = args.filters;
            selectedWorkspace = filters.filter(function (filter) {
              return filter['@type'] === 'sites';
            }).map(function (filter) {
              return filter.values[0];
            }).filter(function (val) {
              return val;
            }).shift();
            if (!userTeamConfig) {
              _context2.next = 11;
              break;
            }
            _context2.next = 8;
            return peopleAndTeamSupplier(args.query, _objectSpread(_objectSpread({
              resolveUserUrl: function resolveUserUrl(userId) {
                return createProfileLink(userId, isGlobalExperienceWorkspace, orgId);
              },
              resolveTeamUrl: function resolveTeamUrl(teamId) {
                return createTeamProfileLink(teamId, isGlobalExperienceWorkspace, orgId);
              }
            }, userTeamConfig), {}, {
              context: _objectSpread(_objectSpread({}, userTeamConfig.context), {}, {
                siteId: selectedWorkspace || userTeamConfig.context.siteId
              })
            }));
          case 8:
            _context2.t0 = _context2.sent;
            _context2.next = 12;
            break;
          case 11:
            _context2.t0 = null;
          case 12:
            people = _context2.t0;
            unsortedSections = [].concat(_toConsumableArray(existingSections.sections), _toConsumableArray((_people$sections2 = people === null || people === void 0 ? void 0 : people.sections) !== null && _people$sections2 !== void 0 ? _people$sections2 : []));
            return _context2.abrupt("return", {
              size: unsortedSections.length,
              sections: unsortedSections.sort(sortSections)
            });
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function postQueryItemSupplierWithPeopleAndTeams(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var preQuerySectionTitleGenerator = function preQuerySectionTitleGenerator(section) {
    switch (section.id) {
      case TownsquareScope.TownsquareProject:
        return intl.formatMessage(messages.townsquare_recent_projects);
      case TownsquareScope.TownsquareGoal:
        return intl.formatMessage(messages.townsquare_recent_goals);
      case TownsquareScope.TownsquareHelpLink:
        return intl.formatMessage(messages.townsquare_recent_help_links);
      case TownsquareScope.TownsquareTag:
        return intl.formatMessage(messages.townsquare_recent_topics);
      case TownsquareScope.TownsquareLearning:
        return intl.formatMessage(messages.townsquare_recent_learnings_risks_decisions);
      case TownsquareScope.People:
        return intl.formatMessage(messages.townsquare_recent_people);
      default:
        return '';
    }
  };
  return {
    preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
    postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
    preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
  };
};